'use strict';

import * as Props from '../Props';

const angular = require('angular');

const DatepickerProperties = {
    Basic: {
        'ControlType': 'Datepicker',
        'Label': {
            name: 'label',
            selectedValue: 'Datepicker',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('Datepicker'),
        'Data Field Name': Props.getDataFieldName('Datepicker'),
        'Display Format': {
            name: 'display.format',
            type: 'dd',
            options: [
                {
                    value: 'default',
                    key: 'Default'
                }, {
                    value: 'DD-MMM-YYYY',
                    key: 'dd-mmm-yyyy'
                }, {
                    value: 'DD-MM-YYYY',
                    key: 'dd-mm-yyyy'
                }, {
                    value: 'DD-MM-YY',
                    key: 'dd-mm-yy'
                }, {
                    value: 'MM-DD-YYYY',
                    key: 'mm-dd-yyyy'
                }, {
                    value: 'MM-DD-YY',
                    key: 'mm-dd-yy'
                }, {
                    value: 'DD/MM/YY',
                    key: 'dd/mm/yy'
                }, {
                    value: 'DD/MM/YYYY',
                    key: 'dd/mm/yyyy'
                }],
            selectedValue: 'default',
            onChangeFunction: 'updateDefaultDate'
        },
        /*'Data Format': {
            name: 'Data Format',
            type: 'dd',
            options: [
                {
                    value: 'dd-M-yy',
                    key: 'dd-mmm-yyyy'
                }, {
                    value: 'dd-mm-yy',
                    key: 'dd-mm-yyyy'
                }, {
                    value: 'dd-mm-y',
                    key: 'dd-mm-yy'
                }, {
                    value: 'mm-dd-yy',
                    key: 'mm-dd-yyyy'
                }, {
                    value: 'mm-dd-y',
                    key: 'mm-dd-yy'
                }, {
                    value: 'dd/mm/y',
                    key: 'dd/mm/yy'
                }, {
                    value: 'dd/mm/yy',
                    key: 'dd/mm/yyyy'
                }],
            selectedValue: 'dd-M-yy'
        },*/
        'Default': {
            name: 'default',
            selectedValue: '',
            type: 'datepicker',
            dateObj: '',
            dateType: '1',
            days: 0,
            onChangeFunction: 'updateDateType'
        },
        'Working Days': {
            name: 'working-days',
            selectedValue: false,
            type: 'checkbox',
            hidden: true,
            icon: 'fa fa-info'
        },
        'Time': {
            name: 'time',
            selectedValue: false,
            type: 'checkbox',
            onChangeFunction: 'updateDefaultDate',
            disable:false
        },
        'Time Format' : {
            name: 'hour_12_format',
            type: 'dd',
            options: [
                {
                    value: true,
                    key: '12Hrs'
                }, {
                    value: false,
                    key: '24Hrs'
                }],
            selectedValue: 'false',
            onChangeFunction: 'updateDefaultDate'
        },
        /*'Min Date': {
            name: 'Min Date',
            type: 'number',
            selectedValue: ''
        },
        'Max Date': {
            name: 'Max Date',
            type: 'number',
            selectedValue: ''
        },*/
        'Required': {
            name: 'required',
            selectedValue: false,
            type: 'checkbox',
            disable: false
        },
        
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        }
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: angular.copy(Props.controlStyleObject),
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Tooltip': {
            name: 'tooltip',
            type: 'textbox',
            selectedValue: ''
        },
        'Tabindex': {
            name: 'tabindex',
            selectedValue: '',
            type: 'number'
        },
        'Searchable': angular.copy(Props.Searchable),
        'Reportable': angular.copy(Props.Reportable),
        'customizable-column': angular.copy(Props.Customizable),
        'Closed Date':{
            name: 'closed.date',
            selectedValue: false,
            type: 'checkbox',
            onChangeFunction: 'enableClosedDateSync'
        },
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    },
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load,
        change: angular.copy(Props.elementEventsObject).change
    }
};

export default DatepickerProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Datepicker.ts